// https://www.npmjs.com/package/react-signature-pad-wrapper
// https://codesandbox.io/p/sandbox/react-signature-drawing-z5r3m?file=%2Fsrc%2FApp.tsx

import React, { useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import SignaturePad from 'react-signature-pad-wrapper'
import { cleanFieldProps, i18nIntl } from '../../lib/ep';
import { useAutoImage, useCSS } from '../../lib/hooks';

import ActionButton from './ActionButton';
import ActionLink from './ActionLink';
import ButtonCollection from './ButtonCollection';
import FieldWrapper from './FieldWrapper';

import FloatingLayerPublic from '../front/FloatingLayerPublic';

const Canvas = (props) => {
	const ref = useRef(null);

	const toDataURL = () => {
		if(!ref.current) return;
		
		const img_data = ref.current.toDataURL();
		//const img = new Blob([ref.current.toDataURL()], { type:'image/png' });

		props.onSign(img_data);
	};

	const clear = () => {
		if(!ref.current) return;
		ref.current.clear();
	};

	const wrapper_props = cleanFieldProps(props);

	return (
		<FieldWrapper type='canvas' {...wrapper_props}>
			<div class="signature_canvas_cont">
				<SignaturePad
					ref={ref}
					redrawOnResize={true}
					options={{
						minWidth:2,
						maxWidth:5,
						//penColor:'rgb(66, 133, 244)',
						backgroundColor:'rgba(255, 255, 255, 1)',
					}}
				/>

				<div>
					<ButtonCollection
						_class={{ other:'flex_button gui_not_in_top_small' }}
					>
						{(props.backButton != undefined) && (
							<ActionButton
								_fullclass=''
								onClick={props.backButton}
							>Close</ActionButton>
						)}

						<ActionButton
							_fullclass=''
							onClick={clear}
						>Clear</ActionButton>

						<ActionButton
							_fullclass=''
							onClick={toDataURL}
						>Save</ActionButton>
					</ButtonCollection>
				</div>
			</div>
		</FieldWrapper>
	)
};

const SignatureCanvas = (props) => {
	useCSS('comp/field_signature.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const value = props?.value ?? props.model[`full_${props.name}`] ?? props.model[props.name];

	const [ display_layer, setDisplayLayer ] = useState(false);
	const [ image, setImage ] = useState( value);

	const onSign = (img) => {
		if(img == undefined || img == false) {
			setDisplayLayer(false);
			return;
		}

		setImage(img);
		setDisplayLayer(false);
	};

	const [ status ] = useAutoImage(props, [image]);

	const wrapper_props = cleanFieldProps(props);

	return (
		<FieldWrapper
			type='signature'
			{...wrapper_props}
		>
			{(image !== false && image !== undefined) ? (
				<span class='signature_cta is_signed' onClick={() => setDisplayLayer(true)}>
					<img src={image} height="50" alt="" />

					<ButtonCollection>
						<ActionLink>Edit</ActionLink>
					</ButtonCollection>
				</span>
			) : (
				<span class='signature_cta' onClick={() => setDisplayLayer(true)}>
					{props?.title ?? i18n("Click here to sign")}
				</span>
			)}

			{(display_layer) && (
				<FloatingLayerPublic
					pm={props.promotion}
					is_builder={props?.is_builder ?? false}
					full_content={true}
					enable_behavior={true}
					backButton={() => setDisplayLayer(false)}
				>
					<Canvas
						_class={{ first:true }}
						backButton={() => setDisplayLayer(false)}
						onSign={onSign}
					/>
				</FloatingLayerPublic>
			)}
		</FieldWrapper>
	)
};

export default injectIntl(SignatureCanvas);